import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';

const { BusinessPrinter } = protos;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function createOrUpdate(request: any): ApiAction {
  return {
    TockApi: {
      postProto: '/business/printer',
      request: BusinessPrinter.fromObject(request),
      type: AppConstants.SAVED_PRINTERS_CREATE,
    },
  };
}

export function destroy(printerId: number): ApiAction {
  return {
    TockApi: {
      deleteProto: `/business/printer/${printerId}`,
      type: AppConstants.SAVED_PRINTERS_DESTROY,
    },
  };
}

export function fetchAll(): ApiAction {
  return {
    TockApi: {
      getListProto: '/business/printer',
      type: AppConstants.SAVED_PRINTERS_FETCH_ALL,
    },
  };
}

export function reset(): BaseTockAction {
  return {
    type: AppConstants.SAVED_PRINTERS_RESET,
  };
}
